import {useContext, useEffect, useState} from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { ProyectoBusqueda } from '../../interfaces/ProyectoBusqueda';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import { RiAlertFill } from "react-icons/ri";
import {TbFileImport, TbSquareLetterX} from 'react-icons/tb' 
import {Alert, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Tooltip, Typography} from '@mui/material';
import {format} from 'date-fns';
import { DataBsqScopus } from '../../interfaces/DataBsqScopus';
import React from 'react';
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from '../../interfaces/ProductoTerminadoDTO';
import ProductoForm from '../Productos/ProductoForm';
import { ProductoTerminadoObjOdDTO, getVoidProductoTerminadoObjOdDTO } from '../../interfaces/ProductoTerminadoObjOdDTO';
import { ProductoAreaConocimientoDTO, getVoidProductoAreaConocimientoDTO } from '../../interfaces/ProductoAreaConocimientoDTO';
import { TblDecInvMotivoProdTermin, getProductoMotivoImport, setProductoMotivo } from '../../interfaces/TblDecInvMotivoProdTermin';
import { ProductoLineaInvestigacionDTO, getVoidProductoLineaInvestigacionDTO } from '../../interfaces/ProductoLineaInvestigacionDTO';
import { TblProductoProdTermin, setProductoScopus, setProductoTerminado } from '../../interfaces/TblProductoProdTermin';
import { ProductoColaboradorDTO } from '../../interfaces/ColaboradorProdcutoDTO';
import { ProductoCoincidencias, Scopus, setScopus } from '../../interfaces/Scopus';
import ProductoService from '../../services/ProductoService';
import AlertService from '../../services/AlertService';
import { ProductoTerminSolicitanteDTO, getVoidProductoTerminSolicitante } from '../../interfaces/ProductoTerminSolicitanteDTO';
import { CasUserContext } from '../../services/casUserContext';
import { IoReturnUpBackSharp } from "react-icons/io5";
import { GetVoidTblDecInvImportadoScopus, TblDecInvImportadoScopus } from '../../interfaces/TblDecInvImportacionScopus';
import { GetProyectoEvntDTO } from '../../interfaces/ProyectosDTOS/EventoProyDTO';
import EventoService from '../../services/EventoService';

const HeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

interface Column {
  id: 'num' | 'sourcetitle' | 'title' | 'autor' | 'tipo' | 'fecha' | 'options' | 'actions';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'num', label: '#', minWidth: 85 },
  { id: 'sourcetitle', label: 'Fuente', minWidth: 100 },
  { id: 'title', label: 'Titulo', minWidth: 150 },
  { id: 'autor', label: 'Autor', minWidth: 90},
  { id: 'tipo', label: 'Tipo de Fuente', minWidth: 85 },
  { id: 'fecha', label: 'Fecha', minWidth: 85 },
  { id: 'options', label: 'Opciones', minWidth: 100},
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const productoService = new ProductoService();
const eventoService = new EventoService();
const alertaService = new AlertService();

export default function BusqScopusTable(props: DataBsqScopus) {
  let history = useNavigate()
  const casUserContext = useContext(CasUserContext);
  const user = casUserContext.userData;
  const token = casUserContext.token;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [inactivo,setInactivo] = useState(true); 
  const [open,setOpen] = useState(false);
  const [openAlert,setOpenAlert] = useState(true);
  const [datosFormulario,setDatosFormulario] = useState<ProductoTerminadoDTO>(()=> getVoidProdcutoTerminadoDTO());
  const [coincidencias,setConincidencias] = useState<ProductoCoincidencias[]>([]);
  const [registro,setRegistro] = useState<TblDecInvImportadoScopus>(()=> GetVoidTblDecInvImportadoScopus())
  const [eid, setEid] = useState('');
 
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResponse = async (responseData: ProductoTerminadoDTO) => {
    // Manejar la respuesta aquí
    //console.log('Respuesta recibida:', responseData);
    setRegistro(GetVoidTblDecInvImportadoScopus);
    registro.iddecinvproyectoprodtermin = responseData.producto.iddecinvproyectoprodtermin;
    registro.idpersona = responseData.motivo.idpersona;
    registro.iddecinvimportadoscopus = 0;
    registro.scopuseid = eid;
    registro.scopusid = user.scopusid;
    //console.log(registro);
    const resp = await productoService.GuardarImportacionScopus(registro,token);
    if(resp.status.isSuccessfully) {
      if(responseData.producto.iddecinvproyecto > 0){
        var evnt = GetProyectoEvntDTO(responseData.producto.iddecinvproyecto,user.idinv,2,"PRODUCTO SCOPUS",responseData.producto.titulo,"");
        const respE = await eventoService.GuardarEvento(evnt,token);
        }
      alertaService.alertaExito("Exito","Se registro el producto.");
      setInactivo(true);
    }else{
      alertaService.alertaAdvertenciaList("Alerta",resp.status.messages);
    }
    goToNavigation('/Producto/MisProductos');
  };
  
  const toggleTab = (tab:string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
 
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const goToNavigation = (site:string) =>{
    history(site)
  }

  const Coincidencias = (lista:Array<ProductoCoincidencias>) =>{
    //console.log(lista);
    setConincidencias(lista);
    handleClickOpen();
  }

  function mensajeCoincidencia(titulo:boolean,doi:boolean): string{
    let mensaje = "Ya existe un producto con el mismo ";
    if(titulo && doi){
      mensaje += "título y DOI."
    }else if(titulo){
      mensaje += "título."
    }else if(doi){
      mensaje += "DOI."
    }else{
      mensaje = "";
    }
    return mensaje;
  } 

  async function insertRowInForm(row:any){
    let respuesta:Scopus = setScopus(row);
    //console.log(row['eid']);
    setEid(row['eid']);
    await fetchData(row);
    //console.log(respuesta);
    setOpenAlert(true);
    setInactivo(false);
  }

  const fetchData = async (row:Scopus) =>{
    try{
         await productoService.ImportarScopus(row,user.token)
         .then((data) => {
            console.log(data);
            setProducto(data)
         })               
         .catch((error) => console.error(error));                       
    }catch(error){
      console.error('Error:',error);
    }
};
function setProducto(data: any) {
    //console.log(data.data);
    setDatosFormulario({
        ...datosFormulario,
        producto: setProductoTerminado(data.data.producto) as TblProductoProdTermin,
        motivo: setProductoMotivo(data.data.motivo) as TblDecInvMotivoProdTermin,
        areaConocimiento: getVoidProductoAreaConocimientoDTO() as ProductoAreaConocimientoDTO,
        lineaInvestigacion: getVoidProductoLineaInvestigacionDTO() as ProductoLineaInvestigacionDTO,
        ods: getVoidProductoTerminadoObjOdDTO() as ProductoTerminadoObjOdDTO,
        colProducto: [] as Array<ProductoColaboradorDTO>,
        solicitantes: [] as Array<ProductoTerminSolicitanteDTO>,            
        //adjuntos: setListFileModel(data.objDatos.adjuntos) as Array<FileModel>,
        idpersona: 0,
        idCategoriaProducto: data.data.idCategoriaProducto as number,
    });
} 

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Grid style={HeaderStyles}>
        <Typography variant="h4" gutterBottom sx={{m:1}}>
          Importar de Scopus
        </Typography>
        <Tooltip title={"Regresar a la tabla"} placement="top" arrow >
          <IconButton aria-label="volver" color="success" onClick={() => setInactivo(true)}>
            <IoReturnUpBackSharp />
          </IconButton>
        </Tooltip>
      </Grid>
      {inactivo ? 
      <>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
            {columns.map((column) => (                
                <StyledTableCell 
                      style={{ minWidth: column.minWidth }}
                      key={column.id}
                      align={column.align}>
                  {column.label}
                  </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.length > 0 ? props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row,index) => {
                return (
                  <StyledTableRow key={row.doi}>
              <StyledTableCell component="th" scope="row">
                {index + 1}
              </StyledTableCell>
              <StyledTableCell align="left">{row.publicationName}</StyledTableCell>
              <StyledTableCell align="left">{row.titulo}</StyledTableCell>
              <StyledTableCell align="left">{row.autor}</StyledTableCell>
              <StyledTableCell align="left">{row.tipo}</StyledTableCell>              
              <StyledTableCell align="left">
                {format(new Date(row.coverDate),'dd/MMM/yyyy')}
              </StyledTableCell>
              <StyledTableCell align="left">
                <Tooltip title={"Importar"} placement="top" arrow >
                  <IconButton aria-label="Importar" color="primary" onClick={() => {insertRowInForm(row)}}>
                    <TbFileImport />
                  </IconButton>
                </Tooltip>
                { row.prodCoincidencias.length > 0 ?
                  <Tooltip title={"Alertas"} placement="top" arrow >
                  <IconButton aria-label="Alerta" color="error" onClick={() => {Coincidencias(row.prodCoincidencias)}}>
                   <RiAlertFill />
                  </IconButton>
                  </Tooltip> 
                  : <></>
                }
              </StyledTableCell>
            </StyledTableRow>
                );
              }):
              <StyledTableRow key={0}>
              <StyledTableCell component="th" scope="row">
                {0}
              </StyledTableCell>
              <StyledTableCell align="left">{''}</StyledTableCell>
              <StyledTableCell align="left">{''}</StyledTableCell>
              <StyledTableCell align="left">{'No se encontraron resultados.'}</StyledTableCell>
              <StyledTableCell align="left">{''}</StyledTableCell>
              <StyledTableCell align="left">{format(new Date(),'dd/MMM/yyyy')}</StyledTableCell>              
              <StyledTableCell align="left"></StyledTableCell>
            </StyledTableRow>
              }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={props.rowsPerPage}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Productos con Coincidencias</DialogTitle>
          <DialogContent>
          <DialogContentText>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Titulo</TableCell>
                  <TableCell>Coincidencia</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {coincidencias.map((producto) => (
                  <TableRow key={producto.idproducto}>
                    <TableCell>{producto.titulo}</TableCell>
                    <TableCell>{mensajeCoincidencia(producto.coincidenciaTitulo,producto.coincidenciaDoi)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
      : 
      <Grid>
        { openAlert ?
          <Alert variant="filled" severity="error" action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpenAlert(false);
              }}
            >
              <TbSquareLetterX  style={{ color: '#ffffff' }} /> 
            </IconButton>
          }>
        Si el producto que desee importar pertenece a un proyecto, la importación deberá realizarla el director del proyecto.
        </Alert>
        : <></>}
        <ProductoForm 
                  productoterminado={datosFormulario} 
                  defaultTipo={24} 
                  defaultCategoria={1} 
                  idProducto={'0'}
                  tiposAvalible={[24,28,46]}
                  categoriasAvalible={[1]} 
                  usoProyectosParticipo={true}
                  onResponse={handleResponse} 
              />
      </Grid> 
      }
    </Paper>
  );
}